<template>
    <v-select
      v-model="dayL"
      :items="days"
      hide-details
      dense
      outlined
    >
      <template v-slot:item="{ item, on, attrs }">
        <v-list-item
          :v-bind="attrs"
          v-on="on"
          @click="changeNumber(item)"
          :disabled="isAllowed(item)"
        >
          <v-list-item-content
          >
            <v-list-item-title>
              {{ item }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  export default {
    name: 'SelectDayPicker',
    props: {
      day: {
        type: Number,
        required: true
      },
      selectedDays: {
        type: Array,
        required: true,
        default: []
      },
      id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        dayL: null,
      }
    },
    watch: {
      day (newVal, oldVal) {
        if (newVal) {
          this.dayL = newVal
        }
      }
    },
    mounted() {
      if (this.day) {
        this.dayL = this.day
      }
    },
    methods: {
      isAllowed(day) {
        return this.selectedDays.includes(day)
      },
      changeNumber(item) {
        this.$emit('update:date', {day: item, id: this.id})
      }
    },
    computed: {
      days () {
        let days = []
        for (let i = 1; i <= 28; i++) {
          days.push(i)
        }
        return days
      }
    }
  }
  </script>
  
  <style>
  
  </style>